import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'articles',
    pathMatch: 'full'
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/layouts/admin-layout/admin-layout.module').then((m) => m.AdminLayoutModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./features/auth/auth.module').then((m) => m.AuthModule)
  },
  {
    path: 'provider',
    loadChildren: () => import('./features/auth/auth.module').then((m) => m.AuthModule)
  }
];

@NgModule({
  imports: [CommonModule, BrowserModule, RouterModule.forRoot(routes, {})],
  exports: []
})
export class AppRoutingModule {}
